<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    if (sessionStorage.getItem('userInfo')) {
      this.$store.commit('setUserInfo', sessionStorage.getItem('userInfo'));
      sessionStorage.removeItem('userInfo');
    } else {
      this.$store.commit('setUserInfo', null);
      sessionStorage.removeItem('userInfo');
    }

    if (sessionStorage.getItem('organs')) {
      this.$store.commit('setOrgans', sessionStorage.getItem('organs'));
      sessionStorage.removeItem('organs');
    } else {
      this.$store.commit('setOrgans', null);
      sessionStorage.removeItem('organs');
    }

    if (sessionStorage.getItem('posts')) {
      this.$store.commit('setPosts', JSON.parse(sessionStorage.getItem('posts')));
      sessionStorage.removeItem('posts');
    } else {
      this.$store.commit('setPosts', null);
      sessionStorage.removeItem('posts');
    }
    if (sessionStorage.getItem('menu')) {
      this.$store.commit('setMenu', sessionStorage.getItem('menu'));
      sessionStorage.removeItem('menu');
    } else {
      this.$store.commit('setMenu', null);
      sessionStorage.removeItem('menu');
    }

    // if (sessionStorage.getItem('menuItems')) {
    //   // 缓存为 JSON 字符串，需解析后存入，并保证是数组
    //   try {
    //     const cachedMenu = JSON.parse(sessionStorage.getItem('menuItems'));
    //     this.$store.commit('setMenuItems', Array.isArray(cachedMenu) ? cachedMenu : []);
    //   } catch (e) {
    //     // 缓存损坏时忽略，保持默认空数组
    //   }
    //   sessionStorage.removeItem('menuItems');
    // } else {
    //   // 无缓存时保持默认空数组 []，由接口 api/menu/setting/list 加载
    //   sessionStorage.removeItem('menuItems');
    // }
    if (sessionStorage.getItem('token')) {
      this.$store.commit('setToken', sessionStorage.getItem('token'));
      sessionStorage.removeItem('token');
    } else {
      this.$store.commit('setToken', null);
      sessionStorage.removeItem('token');
    }

    if (sessionStorage.getItem('currentModule')) {
      this.$store.commit('setCurrentModule', sessionStorage.getItem('currentModule'));
      sessionStorage.removeItem('currentModule');
    } else {
      this.$store.commit('setCurrentModule', 'jbxxgl');
      sessionStorage.removeItem('currentModule');
    }
     // 公共菜单（menuItems）数据源改为接口 api/menu/setting/list
    if (this.$store.state.userInfo && this.$store.state.userInfo.userToken) {
      this.$store.dispatch('getMenuItems');
    }
  },
  mounted() {
    let that = this;
    window.addEventListener('beforeunload', (e) => {
      if (that.$store.state.userInfo) {
        sessionStorage.setItem('userInfo', JSON.stringify(that.$store.state.userInfo));
      }
      if (that.$store.state.organs) {
        sessionStorage.setItem('organs', JSON.stringify(that.$store.state.organs));
      }
      if (that.$store.state.posts) {
        sessionStorage.setItem('posts', JSON.stringify(that.$store.state.posts));
      }
      if (that.$store.state.menu) {
        sessionStorage.setItem('menu', JSON.stringify(that.$store.state.menu));
      }
      // if (that.$store.state.menuItems) {
      //   sessionStorage.setItem('menuItems', JSON.stringify(that.$store.state.menuItems));
      // }
      if (that.$store.state.token) {
        sessionStorage.setItem('token', that.$store.state.token);
      }
      if (that.$store.state.currentModule) {
        sessionStorage.setItem('currentModule', that.$store.state.currentModule);
      }
    });
  },
};
</script>

<style lang="less">
#app {
  font-family: Microsoft YaHei, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: calc(100vh - 8px);
  background: #fff;
  // background-image: url('../src/assets/image/background4706d9.png');
  // background-size: 100% 100%;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
